/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessAddressDto
 */
export interface BusinessAddressDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    streetAddress2?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    stateProvince?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessAddressDto
     */
    timezone?: string;
}

/**
 * Check if a given object implements the BusinessAddressDto interface.
 */
export function instanceOfBusinessAddressDto(value: object): value is BusinessAddressDto {
    return true;
}

export function BusinessAddressDtoFromJSON(json: any): BusinessAddressDto {
    return BusinessAddressDtoFromJSONTyped(json, false);
}

export function BusinessAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'streetAddress': json['street_address'] == null ? undefined : json['street_address'],
        'streetAddress2': json['street_address_2'] == null ? undefined : json['street_address_2'],
        'city': json['city'] == null ? undefined : json['city'],
        'stateProvince': json['state_province'] == null ? undefined : json['state_province'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'country': json['country'] == null ? undefined : json['country'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function BusinessAddressDtoToJSON(json: any): BusinessAddressDto {
    return BusinessAddressDtoToJSONTyped(json, false);
}

export function BusinessAddressDtoToJSONTyped(value?: BusinessAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street_address': value['streetAddress'],
        'street_address_2': value['streetAddress2'],
        'city': value['city'],
        'state_province': value['stateProvince'],
        'postal_code': value['postalCode'],
        'country': value['country'],
        'timezone': value['timezone'],
    };
}

